import { render, staticRenderFns } from "./StatusBadge.vue?vue&type=template&id=477adab4&scoped=true&"
import script from "./StatusBadge.vue?vue&type=script&lang=js&"
export * from "./StatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./StatusBadge.vue?vue&type=style&index=0&id=477adab4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477adab4",
  null
  
)

export default component.exports